export default "__VITE_ASSET__PFAb39D8__"